import { useMemo } from 'react';
import TextEditor from '@components/TextEditor';
import PostDynamicVariables from '@features/PostDynamicVariables';
import { parseTipTapJSONToPlainText } from '@helpers/text-editor';
import { PLACEHOLDER_CONTEXT } from '@constants/placeholders';
import { useTranslation } from '@hooks';
import { LockedLinkChip } from './lockedLinkExtension';

export const MessagePreview = ({ value, onChange, label, required, error }) => {
    const { t } = useTranslation();

    const extraExtensions = useMemo(() => [LockedLinkChip.configure({ label: t('common.link') })], [t]);

    return (
        <TextEditor
            label={label}
            required={required}
            initialValue={value ?? ''}
            onChange={json => onChange?.(json ? parseTipTapJSONToPlainText(json) : '')}
            placeholderContext={PLACEHOLDER_CONTEXT.SEND_SURVEY}
            extraExtensions={extraExtensions}
            error={!!error}
            helperText={error || undefined}
            toolbar={<PostDynamicVariables />}
        />
    );
};

export default MessagePreview;
